import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoOrigemLancamentoCadastroMultiselectComponent } from './novo-origem-lancamento-cadastro-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoOrigemLancamentoCadastroMultiselectComponent],
  exports: [NovoOrigemLancamentoCadastroMultiselectComponent]
})
export class NovoOrigemLancamentoCadastroMultiselectModule {}
